import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_IS_CONVERTING_TO_SUBFLOW = 'SET_IS_CONVERTING_TO_SUBFLOW';
export const SET_IS_ROUTE_SELECTED = 'SET_IS_ROUTE_SELECTED';
export const SET_ROOT_NODE_OF_ROUTE_SELECTION = 'SET_ROOT_NODE_OF_ROUTE_SELECTION';
export const SET_LAST_NODE_OF_ROUTE_SELECTION = 'SET_LAST_NODE_OF_ROUTE_SELECTION';
export const SET_WORKFLOW_GRAPHS = 'SET_WORKFLOW_GRAPHS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_IS_CONVERTING_TO_SUBFLOW](state, value) {
		Vue.set(state, 'isSelectingWorkflowRoute', value);
	},
	[SET_IS_ROUTE_SELECTED](state, value) {
		Vue.set(state, 'isRouteSelected', value);
	},
	[SET_ROOT_NODE_OF_ROUTE_SELECTION](state, value) {
		Vue.set(state, 'rootNodeOfRouteSelection', value);
	},
	[SET_LAST_NODE_OF_ROUTE_SELECTION](state, value) {
		Vue.set(state, 'lastNodeOfRouteSelection', value);
	},
	[SET_WORKFLOW_GRAPHS](state, value) {
		Vue.set(state, 'workflowGraphs', value);
	},
};

export default mutations;
